import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { PointsService } from 'src/app/services/points.service';
import { ProjectService } from 'src/app/services/project.service';
import { RouteSegmentsService } from 'src/app/services/route-segments.service';
import { NavaidsCsvComponent } from '../navaids-csv/navaids-csv.component';
import { ProceduresCsvComponent } from '../procedures-csv/procedures-csv.component';
import { RouteSegmentsCsvComponent } from '../route-segments-csv/route-segments-csv.component';
import { AirspaceVertexComponent } from '../airspace-vertex/airspace-vertex.component';
import { TrajetcoryRvtKmzComponent } from '../trajetcory-rvt-kmz/trajetcory-rvt-kmz.component';
import { NavaidModel } from 'src/app/models/navaid';
import { DuplicateNavaidsComponent } from '../duplicate-navaids/duplicate-navaids.component';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { NavaidsService } from 'src/app/services/navaids.service';
import { FrequencyCorrectedNavaidsComponent } from '../frequency-corrected-navaids/frequency-corrected-navaids.component';
import { ImportFileType } from 'src/app/models/ImportFileType';
import { icaoccModel } from 'src/app/models/icaoccModel';
import { VertexType } from 'src/app/models/VertexType';
import { VertexTypeSelectionComponent } from '../vertex-type-selection/vertex-type-selection.component';
import { ProcedureTypeSelectionComponent } from '../procedure-type-selection/procedure-type-selection.component';
import { ProcedureTypeRef } from 'src/app/models/ProcedureTypeRef';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ProceduresNmAixm51Component } from '../procedures-nm-aixm51/procedures-nm-aixm51.component';
import { PreProcessingToolComponent } from '../../tools/flight-inspection/pre-processing-tool/pre-processing-tool.component';
import { FlightInspectionComponent } from '../flight-inspection/flight-inspection.component';
import { RouteSegmentsXmlComponent } from '../route-segments-xml/route-segments-xml.component';
import { AerodataConfig, CSVConfiguration, EDSConfiguration } from '../../configure-flight-inpection-format/configure-flight-inpection-format.component';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { WietzeToolConfig } from 'src/app/models/FligthInspectionConfig';
import {GritUserService} from "../../../services/grit/grit.user.service";
import {GritDeviceService} from "../../../services/grit/grit.device.service";
import {GritInterferenceTestDeviceService} from "../../../services/grit/grit.interference-test-device.service";
import {GritReceiverService} from "../../../services/grit/grit.receiver.service";
import {DeviceModel, InterferenceTestDeviceModel} from "../../../models/grit/grit.device-model";
import {ReceiverModel} from "../../../models/grit/grit.receiver-model";
import {MapService} from "../../../services/map.service";
import { ImportFormat } from 'src/app/models/importFormat';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['../../../app.component.scss', './import.component.scss'],
  standalone: false
})
export class ImportComponent implements OnInit {

  @Input() entity: string;

  @Input() formatsToDisplay: ImportFormat[];

  openXmlProcedureImport: boolean = false;

  constructor(public bsModalRef: BsModalRef,
    private projectService: ProjectService,
    private pointsController: PointsService,
    private modalService: BsModalService,
    private routeSegmentsService: RouteSegmentsService,
    public confirmationModal: ModalConfirmationService,
    public http: HttpClient,
    public endpointService: EndpointsService,
    private navaidService: NavaidsService,
    public popupService: BsModalService,
    private uiBlock: UiBlockService,
    private messageModal: ModalControlService,
    //#region GRIT
    protected mapService:  MapService,
    protected gritUserService:  GritUserService,
    protected gritDeviceService:  GritDeviceService,
    protected gritInterferenceTestDeviceService:  GritInterferenceTestDeviceService,
    protected gritReceiverService:  GritReceiverService,
    //endregion
    ) {
   }

  ngOnInit(): void {
  }

  validFlightInspectionFileFormat(flightInspectionFormat: string, fileFormat: string){
    switch(flightInspectionFormat){
      case "CSV": return "csv" == fileFormat;
      case "Aerodata": return "txt" == fileFormat;
      case "EDS": return "txt" == fileFormat;
    }
  }

  //#region GRIT
  async importJson(fileToUpload: File){
    let group  = (document.getElementById("groupSelect") as HTMLSelectElement)?.value ?? ""  ;

    switch (this.entity) {
      case "RFI-Transmitters":
        let devicesJson : any[] = JSON.parse(await fileToUpload[0].text())
        let devices = devicesJson.map(d => new DeviceModel().importJson(d, group))
        this.gritDeviceService.importDevices(devices);
        break;
      case "Map RFI-Transmitters":
        let itDevicesJson : any[] = JSON.parse(await fileToUpload[0].text())
        let projection = this.mapService.getMaps().getView().getProjection();
        let itDevices = itDevicesJson.map(d => new InterferenceTestDeviceModel().importJson(d, group, projection))
        this.gritInterferenceTestDeviceService.importItDevices(itDevices);
        break;
      case "Receivers":
        let receiversJson : any[] = JSON.parse(await fileToUpload[0].text())
        let receivers = receiversJson.map(r => new ReceiverModel().importJson(r, group))
        this.gritReceiverService.importReceivers(receivers);
        break;
    }
    this.cancel();
  }
  //endregion

  uploadFile(event:any, format : string){
    if (this.projectService.projectEditable()){
      switch(this.entity){
        case 'NavAids':
          switch (format) {
            case 'XML':
              this.uploadNavAidXMLFile(event);
              break;
            case 'EAD AIXM 4.5':
              this.uploadNavAidEAD45File(event);
              break;
            case 'EAD AIXM 5.1':
              this.uploadNavAidEAD51File(event);
              break;
            case 'NM AIXM 5.1':
              this.uploadNavAidNMAIXM51File(event);
              break;
            case 'ARINC 424':
              this.uploadNavAidArinc424File(event);
              break;
            case 'SAFIRE':
              this.uploadNavAidSafireFile(event);
              break;
          }
          break;
        case 'Coordinate Points':
          switch (format) {
            case 'XML':
              this.uploadCpXMLFile(event, format)
              break;
            case 'EAD AIXM 4.5':
              this.uploadCoordPointsEAD45File(event, format);
              break;
            case 'EAD AIXM 5.1':
              this.uploadVertexEADFile(event, true, true);
              break;
            case 'NM AIXM 5.1':
              this.uploadCoordPointsNMAIXM51File(event, format);
              break;
            case 'ARINC 424':
              this.uploadCoordPointsArinc424File(event, format)
              break;
          }
          break;
        case 'Procedures':
          switch (format) {
            case 'XML':
              this.uploadProcedureXML(event);
              break;
            case 'CSV':
              this.uploadProcedureCSV();
              break;
            case 'EAD AIXM 4.5':
              this.uploadProcedureEADFile(event, false);
              break;
            case 'EAD AIXM 5.1':
              this.uploadProcedureEADFile(event, true);
              break;
            case 'NM AIXM 5.1':
              this.uploadProcedureNMAIXM51();
              break;
            case 'ARINC 424':
              this.uploadProcedureArinc424File(event)
              break;
          }
          break;
        case 'RouteSegments':
          if (format == 'CSV') {
            this.uploadRouteSegmentsCSV();
          }
          if (format == 'EAD AIXM 4.5') {
            this.uploadRouteSegmentsXML(false);
          }
          if (format == 'EAD AIXM 5.1') {
            this.uploadRouteSegmentsXML(true);
          }
          break;
        case 'RVT/KMZ':
          this.uploadTrajectory(format);
          break;
        case 'Air Space Boundaries':
          this.uploadAirSpaceBoundaryXML(event);
          break;
        case 'Vertex':
          if (format == 'EAD AIXM 4.5') {
            this.uploadVertexEADFile(event, false, false);
          }
          else if (format == 'EAD AIXM 5.1') {
            this.uploadVertexEADFile(event, false, true);
          } else if (format == 'CSV') {
            break;
          }
          break;
        case 'Aerodromes':
          switch (format) {
            case 'EAD AIXM 4.5':
              this.uploadAerodromeEADFile(event, ImportFileType.AERODROMES_EAD_45, format);
              break;
            case 'EAD AIXM 5.1':
              this.uploadAerodromeEADFile(event, ImportFileType.AERODROMES_EAD_51, format);
              break;
            case 'NM AIXM 5.1':
              this.uploadAerodromeNMAIXM51File(event, format);
              break;
          }
          break;
        case 'Flight Inspections':
          let fileNameSplit: string[] = event[0].name.split(".");
          if (!this.validFlightInspectionFileFormat(format, fileNameSplit[fileNameSplit.length - 1])) {
            this.messageModal.showMesssageModal("Error", "Selected file has wrong format");
            return;
          }

          const bsRef = this.popupService.show(FlightInspectionComponent);
          bsRef.content.file = event[0];
          bsRef.content.fileName = event[0].name
          let layerName: string = event[0].name.split(".")[0];
          layerName.length > 20 ? layerName = layerName.substring(0, 20) : false;
          bsRef.content.layerName = layerName;
          bsRef.content.fileFormat = format;

          if (format == "CSV") {
            bsRef.content.importConfig = new CSVConfiguration();
          }
          else if (format == "EDS") {
            bsRef.content.importConfig = new EDSConfiguration();
          }
          else if (format == "Aerodata") {
            bsRef.content.importConfig = new AerodataConfig();
          }
          break;
        case "Flight Inspection Processing Tool":
          this.getAndOpenProcessingToolConfig(event, format);
          break;
      }
    }
    this.bsModalRef.hide();
  }

  getAndOpenProcessingToolConfig($files: any, format: string, defaultConfig?: any) {
    let toSendFormat: string;
    defaultConfig == null ? toSendFormat = WietzeToolConfig.DEFAULT_FORMAT : toSendFormat = format;
    this.http
      .get<any>(
        this.endpointService.endpointGetFlightInspectionConfig + '/' + toSendFormat,
        this.endpointService.httpOptions
      ).subscribe((config: any) => {
        if (config == null) {
          this.messageModal.showMesssageModal(
            'Processing Tool',
            'There was an error fetching the prefined configuration.'
          );
          return;
        }
        if (defaultConfig == null) {
          // assign fetched config to default config and fetch the other config
          this.getAndOpenProcessingToolConfig($files, format, config);
        } else {
          //open component
          const bsRef = this.popupService.show(FlightInspectionComponent);
          bsRef.content.isProcessingTool = true;
          bsRef.content.file = $files[0];
          bsRef.content.fileName = $files[0].name;
          let layerName: string = $files[0].name.split(".")[0];
          layerName.length > 20 ? layerName = layerName.substring(0, 20) : false;
          bsRef.content.layerName = layerName;
          bsRef.content.fileFormat = format;
          bsRef.content.importConfig = config;
          bsRef.content.defaultConfig = defaultConfig;
        }
      },
        () => {
          this.messageModal.showMesssageModal(
            'Processing Tool',
            'There was an error fetching the prefined configuration.'
          )
        }
      );
  }

  getFormatedDate(value) {
    if (value != null && value.includes('T')) {
      value = value.substring(0, value.indexOf('T'));
    }
    if (value == null) {
      return null;
    }
    let testDateFormatDesktop = moment(value, 'DD-MM-YYYY', true).isValid();

    if (testDateFormatDesktop) {
      return moment(value, 'DD-MM-YYYY', true).format("yyyy-MM-DD");
    } else {
      return moment(value, 'YYYY-MM-DD', true).format("yyyy-MM-DD");
    }
  }

  removeDuplicatesFromNavaids(duplicates: Map<string, NavaidModel[]>, navaids: NavaidModel[]) {
    let navaidWithoutDuplicates = [];
    for (let navaid of navaids) {
      if (!duplicates.has(navaid.navaidid + navaid.icaocc)) {
        navaidWithoutDuplicates.push(navaid);
      }
    }
    return navaidWithoutDuplicates;
  }
  uploadNavaidXML(fileToUpload: File) {
    this.uiBlock.startBlock('Parsing XML file...');
    this.pointsController.uploadNavaidsXMLHttpRequest(fileToUpload)
      .subscribe((navaids: NavaidModel[]) => {
        this.uiBlock.stopBlock();
        if (!navaids || navaids.length == 0) {
          this.messageModal.showMesssageModal(
            'Error importing',
            "No available NavAids in file. Please make sure you are importing the correct XML file."
          );
          return;
        }
        DuplicateNavaidsComponent.importCheckForDuplicates(navaids, this.modalService, this.pointsController, this.navaidService, "XML");
      },
        (error) => {
          this.uiBlock.stopBlock();
          this.pointsController.handleImportError(error, "XML");
        }
      );
  }
  uploadNavAidSafire(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.uiBlock.startBlock('Parsing Safire file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileNavaids + '/' + ImportFileType.NAVAIDS_SAFIRE,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((navaids: NavaidModel[]) => {
        this.uiBlock.stopBlock();
        DuplicateNavaidsComponent.importCheckForDuplicates(navaids, this.modalService, this.pointsController, this.navaidService, "SAFIRE");
      },
        () => {
          this.uiBlock.stopBlock();
          this.messageModal.showMesssageModal(
            'Error importing',
            'There was an error parsing the file. Please make sure you are importing the correct Safire file.'
          )
        }

      );
  }
  uploadNavAidArinc424(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.uiBlock.startBlock('Parsing ARINC 424 file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileNavaids + '/' + ImportFileType.NAVAIDS_ARINC424,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((navaids: NavaidModel[]) => {
        this.uiBlock.stopBlock();
        DuplicateNavaidsComponent.importCheckForDuplicates(navaids, this.modalService, this.pointsController, this.navaidService, "XML");
      },
        (error) => {
          this.uiBlock.stopBlock();
          this.pointsController.handleImportError(error, "ARINC 424");
        }

      );
  }


  uploadNavaidEAD45(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.uiBlock.startBlock('Parsing XML file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileNavaids + '/' + ImportFileType.NAVAIDS_EAD_45,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((navaids: NavaidModel[]) => {
        this.uiBlock.stopBlock();
        FrequencyCorrectedNavaidsComponent.importCheckForCorrections(navaids, this.modalService, this.pointsController, this.navaidService);
      },
        (error) => {
          this.uiBlock.stopBlock();
          this.pointsController.handleImportError(error, "XML");
        }

      );
  }

  uploadNavaidEAD51(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.uiBlock.startBlock('Parsing XML file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileNavaids + '/' + ImportFileType.NAVAIDS_EAD_51,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe(async (navaids: NavaidModel[]) => {
        this.uiBlock.stopBlock();
        this.uiBlock.startBlock("Loading NavAids ICAO Codes...");
        await this.navaidService.fillIso2CodesForNavaidsList(navaids);
        this.navaidService.getAllIcaoCountryCodes().subscribe((icaoList: icaoccModel[]) => {
          for (let i = 0; i < navaids.length; i++) {
            const icaocc = icaoList.find(icaoccModel => icaoccModel.iso2code == navaids[i].icaocc);
            if (icaocc != null) {
              navaids[i].icaocc = icaocc.icaocode;
            } else {
              // remove navaid from list
              navaids.splice(i, 1);
              i--;
            }
          }
          this.uiBlock.stopBlock();
          FrequencyCorrectedNavaidsComponent.importCheckForCorrections(navaids, this.modalService, this.pointsController, this.navaidService);
        })
      },
        (error) => {
          this.uiBlock.stopBlock();
          this.pointsController.handleImportError(error, "XML");
        }
      );
  }

  uploadNavaidNMAIXM51(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.uiBlock.startBlock('Parsing NM AIXM 5.1 file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileNavaids + '/' + ImportFileType.NAVAIDS_NM_AIXM51,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe(async (navaids: NavaidModel[]) => {
        this.uiBlock.stopBlock();
        this.uiBlock.startBlock("Loading NavAids ICAO Codes...");
        await this.navaidService.fillIso2CodesForNavaidsList(navaids);
        this.navaidService.getAllIcaoCountryCodes().subscribe((icaoList: icaoccModel[]) => {
          for (let i = 0; i < navaids.length; i++) {
            const icaocc = icaoList.find(icaoccModel => icaoccModel.iso2code == navaids[i].icaocc);
            if (icaocc != null) {
              navaids[i].icaocc = icaocc.icaocode;
            } else {
              // remove navaid from list
              navaids.splice(i, 1);
              i--;
            }
          }
          this.uiBlock.stopBlock();
          DuplicateNavaidsComponent.importCheckForDuplicates(navaids, this.modalService, this.pointsController, this.navaidService, "NM AXIM 5.1");
        })
      },
        (error) => {
          this.uiBlock.stopBlock();
          this.pointsController.handleImportError(error, "NM AIXM 5.1");
        }
      );
  }

  uploadNavAidXMLFile($files: any) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Warning!", "This action will override the existing data.Do you want to continue?", "OK", "Cancel", () => this.uploadNavaidXML($files[0]))
    }
  }
  uploadNavAidArinc424File($files: any) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() => this.uploadNavAidArinc424($files[0]));
    }
  }

  uploadNavAidSafireFile($files: any) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() => this.uploadNavAidSafire($files[0]));
    }
  }

  uploadNavAidEAD45File($files: any) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() => this.uploadNavaidEAD45($files[0]))
    }
  }

  uploadNavAidEAD51File($files: any) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() => this.uploadNavaidEAD51($files[0]))
    }
  }

  uploadNavAidNMAIXM51File($files: any) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() => this.uploadNavaidNMAIXM51($files[0]))
    }
  }

  uploadCpXMLFile($files: any, format: string) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Warning!", "This action will override the existing data.Do you want to continue?", "OK", "Cancel",
        () => this.pointsController.uploadCP($files[0], ImportFileType.COORDINATE_POINTS_XML, format));
    }
    //target.value = '';
  }

  uploadVertexEADFile($files: any, importAerodromes: boolean, isEad51: boolean) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Warning!", "This action will override the existing data.Do you want to continue?", "OK", "Cancel", () => this.uploadVertexEAD($files[0], importAerodromes, isEad51));
    }
  }

  uploadCoordPointsEAD45File($files: any, format: string) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() =>
      this.pointsController.uploadCP($files[0], ImportFileType.COORDINATE_POINTS_EAD45, format))
    }
  }

  uploadCoordPointsNMAIXM51File($files: any, format: string) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() =>
      this.pointsController.uploadCP($files[0], ImportFileType.COORDINATE_POINTS_NM_AIXM51, format))
    }
  }

  uploadCoordPointsArinc424File($files: any, format: string) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() =>
      this.pointsController.uploadCP($files[0], ImportFileType.COORDINATE_POINTS_ARINC424, format))
    }
  }

  uploadAerodromeEADFile($files: any, importType: ImportFileType, format: string) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Warning!", "This action will override the existing data.Do you want to continue?", "OK", "Cancel", () =>
        this.pointsController.uploadCP($files[0], importType, format));
    }
  }

  uploadAerodromeNMAIXM51File($files: any, format: string) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() =>
      this.pointsController.uploadCP($files[0], ImportFileType.AERODROMES_NM_AIXM51, format))
    }
  }

  uploadProcedureEADFile($files: any, isEad51: boolean) {
    //let target = $event.target || $event.srcElement;
    if (this.projectService.projectEditable()) {
      this.uploadProcedureEAD($files[0], isEad51);
    }
  }


  uploadProcedureEAD(fileToUpload: File, isEad51) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    let importType: ImportFileType;
    isEad51 ? importType = ImportFileType.PROCEDURES_EAD_51_PHASE1 : importType = ImportFileType.PROCEDURES_EAD_45_PHASE1;
    this.uiBlock.startBlock('Parsing XML file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileProcedures + '/' + importType,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((procedureTypeList: ProcedureTypeRef[]) => {
        this.uiBlock.stopBlock();
        if (procedureTypeList.length > 0) {
          const bsRef: BsModalRef = this.modalService.show(ProcedureTypeSelectionComponent);
          bsRef.content.formData = formData;
          bsRef.content.procedureTypeMap = ProcedureTypeSelectionComponent.createProcedureTypeMap(procedureTypeList, isEad51);
          bsRef.content.procedureTypeRowExpanded = ProcedureTypeSelectionComponent.createRowActiveProperty(bsRef.content.procedureTypeMap);
          bsRef.content.isEad51 = isEad51;
        } else {
          this.messageModal.showMesssageModal(
            'Error importing',
            "No available Procedures in file. Please make sure you are importing the correct XML file."
          );
        }
      },
        (error) => {
          this.uiBlock.stopBlock();
          this.pointsController.handleImportError(error, "XML");
        }
      );
  }


  uploadProcedureArinc424File($files: any) {
    this.bsModalRef.hide();
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() => this.pointsController.uploadProcedureFromArinc424($files[0]));
    }
  }

  uploadVertexEAD(fileToUpload: File, importAerodromes: boolean, isEad51: boolean) {
    let importType: ImportFileType;
    isEad51 ? importType = ImportFileType.VERTEX_EAD_51_PHASE1 : importType = ImportFileType.VERTEX_EAD_45_PHASE1;
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.uiBlock.startBlock('Parsing XML file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileCoordinatePoints + '/' + importType,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((vertexTypeList: VertexType[]) => {
        this.uiBlock.stopBlock();
        if (vertexTypeList.length > 0) {
          const bsRef: BsModalRef = this.modalService.show(VertexTypeSelectionComponent);
          bsRef.content.formData = formData;
          bsRef.content.vertexTypeMap = VertexTypeSelectionComponent.createVertexTypeMap(vertexTypeList);
          bsRef.content.vertexTypeRowExpanded = VertexTypeSelectionComponent.createRowActiveProperty(bsRef.content.vertexTypeMap);
          bsRef.content.importAerodromes = importAerodromes;
          bsRef.content.isEad51 = isEad51;
        } else {
          this.messageModal.showMesssageModal(
            'Error importing',
            "No available Vertexes in file. Please make sure you are importing the correct file."
          );
          if (importAerodromes) {
            this.pointsController.uploadCP(fileToUpload, ImportFileType.AERODROMES_EAD_51, "XML");
          }
        }
      },
        (error) => {
          this.uiBlock.stopBlock();
          this.pointsController.handleImportError(error, "XML");
        }
      );
  }

  uploadProcedureXML($files: FileList) {

    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Warning!", "This action will override the existing data.Do you want to continue?", "OK", "Cancel", () => this.pointsController.uploadProcedure($files[0]));
    }
    this.bsModalRef.hide();
  }

  uploadProcedureCSV() {
    this.bsModalRef.hide();
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Warning!", "This action will override the existing data.Do you want to continue?", "OK", "Cancel", () => this.modalService.show(ProceduresCsvComponent));
    }
  }

  uploadProcedureNMAIXM51() {
    this.bsModalRef.hide();
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Update Information",
      'During the update process:\n' +
      '- Fields present on EAD file and on GRIT database will be overwritten and the information on GRIT database will be updated.\n' +
      '- Fields missing on the EAD file but present on GRIT database will be preserved.', "OK","Cancel",() => this.modalService.show(ProceduresNmAixm51Component));
    }
  }


  uploadNavaidsCSV() {
    this.bsModalRef.hide();
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Warning!", "This action will override the existing data.Do you want to continue?", "OK", "Cancel", () => this.modalService.show(NavaidsCsvComponent));
    }
  }

  uploadProcedureFromRouteSegmentCSV() {
    this.bsModalRef.hide();
    if (this.projectService.projectEditable()) {
      this.routeSegmentsService.isCreateProcedureFromRouteSegment = true;
      const bsModalRef: BsModalRef = this.modalService.show(RouteSegmentsCsvComponent);
    }
  }

  uploadRouteSegmentsCSV() {
    this.bsModalRef.hide();
    if (this.projectService.projectEditable()) {
      this.routeSegmentsService.isCreateProcedureFromRouteSegment = false;
      const bsModalRef: BsModalRef = this.modalService.show(RouteSegmentsCsvComponent);
    }
  }

  uploadRouteSegmentsXML(isEad51: boolean) {
    this.bsModalRef.hide();
    if (this.projectService.projectEditable()) {
      const bsModalRef: BsModalRef = this.modalService.show(RouteSegmentsXmlComponent);
      bsModalRef.content.isEad51 = isEad51;
    }
  }

  uploadAirSpaceBoundaryXML($files: FileList) {
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Warning!", "This action will override the existing data.Do you want to continue?", "OK", "Cancel", () => this.pointsController.uploadAirSpaceBoundary($files[0]));
    }
    this.bsModalRef.hide();
  }


  uploadVertexCSV() {
    this.bsModalRef.hide();
    if (this.projectService.projectEditable()) {
      const bsModalRef: BsModalRef = this.modalService.show(AirspaceVertexComponent);
    }
  }

  uploadTrajectory(format: string) {
    this.bsModalRef.hide();
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Warning!", "This action will override the existing data.Do you want to continue?", "OK", "Cancel",
        () => {
          let bsModalRef: BsModalRef = this.modalService.show(TrajetcoryRvtKmzComponent)
          bsModalRef.content.format = format;
        });
    }
  }

  cancel() {
    this.bsModalRef.hide();
  }

}
